import { DEFAULT_ANIMATE_DURATION, NextImage } from '@apeiron/temp'
import { Box, styled } from '@mui/material'
import { AnimationEvent, FC, ReactNode } from 'react'

const Background = styled(Box)`
  position: relative;
`

const CornerContainer = styled(Box)`
  height: 100%;
  opacity: 0.6;
  overflow: hidden;
  position: absolute;
  width: 100%;
`

const Container = styled(Box)`
  position: relative;
  width: 100%;
  height: 100%;
`

const TopLeft = styled(NextImage)`
  @keyframes slideFromTopLeft {
    0% {
      transform: translate(-100%, -100%);
    }
    100% {
      transform: translate(0, 0);
    }
  }

  animation: ${DEFAULT_ANIMATE_DURATION * 2}ms ease-out slideFromTopLeft;
  left: 0;
  position: absolute;
  top: 0;
`

const BottomLeft = styled(NextImage)`
  @keyframes slideFromBottomLeft {
    0% {
      transform: translate(-100%, 100%);
    }
    100% {
      transform: translate(0, 0);
    }
  }

  animation: ${DEFAULT_ANIMATE_DURATION * 2}ms ease-out slideFromBottomLeft;
  bottom: 0;
  left: 0;
  position: absolute;
`

const TopRight = styled(NextImage)`
  @keyframes slideFromTopRight {
    0% {
      transform: translate(100%, -100%);
    }
    100% {
      transform: translate(0, 0);
    }
  }

  animation: ${DEFAULT_ANIMATE_DURATION * 2}ms ease-out slideFromTopRight;
  position: absolute;
  right: 0;
  top: 0;
`

const BottomRight = styled(NextImage)`
  @keyframes slideFromBottomRight {
    0% {
      transform: translate(100%, 100%);
    }
    100% {
      transform: translate(0, 0);
    }
  }

  animation: ${DEFAULT_ANIMATE_DURATION * 2}ms ease-out slideFromBottomRight;
  bottom: 0;
  position: absolute;
  right: 0;
`

const ApeironCorneredBox: FC<Props> = (props: Props) => {
  const {
    bottomLeft,
    bottomRight,
    children,
    className,
    topLeft,
    topRight,
    onAnimationEnd
  } = props

  return (
    <Background className={className}>
      <CornerContainer className='Custom-Corner-Container'>
        <BottomLeft
          onAnimationEnd={onAnimationEnd}
          className='Custom-Bottom-Left'
          src={bottomLeft}
        />
        <BottomRight className='Custom-Bottom-Right' src={bottomRight} />
        <TopLeft className='Custom-Top-Left' src={topLeft} />
        <TopRight className='Custom-Top-Right' src={topRight} />
      </CornerContainer>
      <Container className='Custom-Container'>{children}</Container>
    </Background>
  )
}

type Props = {
  bottomLeft: string
  bottomRight: string
  children: ReactNode
  className?: string
  topLeft: string
  topRight: string
  onAnimationEnd?: (event: AnimationEvent<HTMLImageElement>) => void
}

export default ApeironCorneredBox
